import { render, staticRenderFns } from "./MailNotification.vue?vue&type=template&id=1a685fd3&scoped=true"
import script from "./MailNotification.vue?vue&type=script&lang=js"
export * from "./MailNotification.vue?vue&type=script&lang=js"
import style0 from "./MailNotification.vue?vue&type=style&index=0&id=1a685fd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a685fd3",
  null
  
)

export default component.exports